export default __webpack_public_path__ + "static/media/netflix-front.fe7bdd2e.png";